import { camelizeKeys } from 'humps';
import { isEmpty, uniq } from 'lodash-es';
import { z } from 'zod';
import { post } from '@namespace/helpers';
import { validateScheme } from '@namespace/helpers/src/utils/validateSchema';
import { UserParticipatedBonusesType } from '../../store/types';
import { GetBonusesResponseSchema, GetParsedBonusesSchema } from './schemas';

type GetBonusesResponse = z.infer<typeof GetBonusesResponseSchema>;

type PostResponse<ResponseType> = {
  status: string;
  data: ResponseType;
};

export const getUserBonuses = async (options: {
  crmBonusTemplateIds: number[];
  bsBonusTemplateIds: number[];
}): Promise<UserParticipatedBonusesType> => {
  const { status, data }: PostResponse<GetBonusesResponse> = await post(
    `/service/bff/v1/bonuses/lobby/get`,
    {
      crm_bonus_template_ids: uniq(options.crmBonusTemplateIds),
      ...(!isEmpty(options.bsBonusTemplateIds) && {
        bs_bonus_template_ids: uniq(options.bsBonusTemplateIds)
      })
    }
  );

  if (status === 'success') {
    const parsedResponse = camelizeKeys(data.bonuses);
    validateScheme(GetParsedBonusesSchema, parsedResponse, {
      name: 'getUserBonuses'
    });
    return parsedResponse as UserParticipatedBonusesType;
  }

  return [];
};
